// Map for current options in the variant
const map = {
    1: [2, 3],
    2: [1, 3],
    3: [1, 2],
};
function updateOptionsInSelector(selectorIndex, parent) {
    let key = document.querySelector(parent + ` [data-option="option${selectorIndex}"]`)?.value;
    if (key) {
        let availableOptions = Shopify.optionsMap[key];
        if (document.querySelector(".product-page").classList.contains("template-shop-by-look")) {
            let productId = document.querySelector(parent).getAttribute("data-sbl-product-wrapper");
            availableOptions = Shopify.products[productId].optionsMap[key];
        }
        map[selectorIndex].forEach((option) => {
            document
                .querySelectorAll(parent + ` .swatch[data-option-index="${option - 1}"] .swatch-element`)
                ?.forEach(function (element) {
                    if (availableOptions && availableOptions.includes(element.getAttribute("data-value"))) {
                        element.classList.remove("soldout");
                        element.querySelector('input[type="radio"]')?.removeAttribute("disabled");
                        element.querySelector('input[type="radio"]')?.removeAttribute("checked");
                    } else {
                        element.classList.add("soldout");
                        element.querySelector('input[type="radio"]')?.removeAttribute("checked");
                        element.querySelector('input[type="radio"]')?.setAttribute("disabled", "disabled");
                    }
                });
        });
    }
}
export function linkOptionSelectors(product, parent) {
    Shopify.optionsMap = {};
    Shopify.products = Shopify.products || {};
    Shopify.products[product.id] = {};
    Shopify.products[product.id].optionsMap = {};
    for (let i = 0; i < product.variants.length; i++) {
        let variant = product.variants[i];
        if (variant.available) {
            if (product.options.length > 1) {
                Object.keys(map).forEach((index) => {
                    if (typeof variant[`option${index}`] !== "undefined") {
                        let key = variant[`option${index}`];
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.products[product.id].optionsMap[key] =
                            Shopify.products[product.id].optionsMap[key] || [];
                        let options = map[index];
                        options.forEach((option) => {
                            if (typeof variant[`option${option}`] !== "undefined") {
                                if (!Shopify.optionsMap[key].includes(variant[`option${option}`])) {
                                    Shopify.optionsMap[key].push(variant[`option${option}`]);
                                }
                                if (
                                    !Shopify.products[product.id].optionsMap[key].includes(variant[`option${option}`])
                                ) {
                                    Shopify.products[product.id].optionsMap[key].push(variant[`option${option}`]);
                                }
                            }
                        });
                    }
                    updateOptionsInSelector(index, parent);
                });
            }
        }
    }
    $(parent + " .single-option-selector").change((e) => {
        let setOptionIndex = e.target.getAttribute("data-option").replace(/^\D+/g, "");
        updateOptionsInSelector(setOptionIndex, parent);

        return true;
    });
}
